import { NAV_HEIGHT } from 'Layout/MyAccountLayout/dimensions';
import { HEADER_HEIGHT } from 'crazyEditor/core/constants/editorConstants';
export default {
  zIndexEditBoxKnob: 500,
  zIndexContextMenu: 700,
  zIndexMouseCatcher: 1000,
  zIndexEditorLeftBar: 1400,
  zIndexControlsMenu: 1400,
  zIndexToolbar: 1500,
  zIndexToolbarNotifications: 1600,
  zIndexModalDialog: 2000,
  zIndexWindowBusy: 10000,
  zIndexIntegrationIframe: 9999,
  headerHeight: HEADER_HEIGHT,
  toolbarHeight: NAV_HEIGHT,
};
